import React, { useCallback, useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Gavel } from "lucide-react";
import { toast } from "sonner";

const fm = (n) => Math.round(n).toLocaleString("en-US");
const COL = { open: "#F59E0B", accepted: "#00FF7F", declined: "#EF4444", outbid: "#64748b" };

export const LotBids = ({ lotId }) => {
  const [bids, setBids] = useState(null);
  const load = useCallback(() => api.get(`/micro/lots/${lotId}/bids`).then((r) => setBids(r.data)).catch(() => setBids([])), [lotId]);
  useEffect(() => { load(); }, [load]);
  const decide = async (id, decision) => { try { await api.post(`/micro/bids/${id}/${decision}`); toast.success(`Bid ${decision === "accept" ? "accepted" : "declined"} · anchored`); load(); } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } };
  if (!bids) return null;
  return (
    <div className="space-y-1" data-testid="lot-bids">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 inline-flex items-center gap-1"><Gavel className="h-3 w-3" /> Buyer bids · {bids.length}</div>
      {bids.length === 0 && <div className="text-[11px] text-slate-500">No bids yet — this lot is listed on the public <a className="text-[#00FFFF] underline" href="/offers" target="_blank" rel="noreferrer">offers page</a>.</div>}
      {bids.map((b) => (
        <div key={b.id} className="flex flex-wrap items-center gap-2 text-[11px] border-t border-white/5 py-1" data-testid={`bid-row-${b.id}`}>
          <span className="text-slate-100">{b.buyer_name}{b.organisation ? ` · ${b.organisation}` : ""}</span><span className="text-slate-500">{b.buyer_email}</span>
          {b.variant_key && <span className="text-slate-400 font-mono">{b.variant_key}</span>}
          <span className="font-mono text-slate-300">{b.quantity} × {fm(b.unit_price_try)} = <span className="text-[#00FF7F]">{fm(b.total_try)} TRY</span></span>
          <span className="font-mono uppercase" style={{ color: COL[b.status] }} data-testid={`bid-status-${b.id}`}>{b.status}</span>
          {b.status === "open" && <><button data-testid={`bid-accept-${b.id}`} onClick={() => decide(b.id, "accept")} className="border border-[#00FF7F]/50 text-[#00FF7F] px-2 py-0.5">accept</button><button data-testid={`bid-decline-${b.id}`} onClick={() => decide(b.id, "decline")} className="border border-[#EF4444]/50 text-[#EF4444] px-2 py-0.5">decline</button></>}
          {b.note && <span className="text-slate-500 w-full">{b.note}</span>}
        </div>
      ))}
    </div>
  );
};
